'use client';

import Cross from '../../../../public/images/company/icon-cross.svg';
import Drop from '../../../../public/images/company/icon-drop.svg';
import Heart from '../../../../public/images/company/icon-heart.svg';

type Props = {
    locationStatistics: {
        laboratories: number;
        samplingPoints: number;
    };
};

export default function Highlights({ locationStatistics }: Props) {
    return (
        <ul className="flex flex-col gap-8 text-center md:flex md:flex-row">
            <li className="flex flex-1 items-center gap-8 px-4 md:block">
                <Cross className="mb-8 inline-block h-24 w-1/3 md:h-40 md:w-auto xl:h-64" />
                <div className="mx-auto md:w-1/2">Peste 2700 investigații de laborator</div>
            </li>
            <li className="flex flex-1 items-center gap-8 px-4 md:block">
                <Drop className="mb-8 inline-block h-24 w-1/3 md:h-40 md:w-auto xl:h-64" />
                <div className="mx-auto w-1/2">
                    {locationStatistics.laboratories} laboratoare, {locationStatistics.samplingPoints} centre de
                    recoltare în toată țara
                </div>
            </li>
            <li className="flex flex-1 items-center gap-8 px-4 md:block">
                <Heart className="mb-8 inline-block h-24 w-1/3 md:h-40 md:w-auto xl:h-64" />
                <div className="mx-auto w-1/2">Aparatură modernă</div>
            </li>
        </ul>
    );
}
